import React, { useState } from 'react';
import {
  Typography,
  Box,
  TextField,
  Divider,
  IconButton,
} from '@material-ui/core';
import Dropdown from 'components/form/Dropdown';
import DatePickerLabel from 'components/common/DatePickerLabel';
import EditIcon from '@material-ui/icons/Edit';
import SaveIcon from '@material-ui/icons/Save';
import useSnack from 'hooks/useSnack';

const submitOptions = [
  {
    value: true,
    label: 'Submitted',
    backgroundColor: '#E7F7E1',
    color: '#8ED76E',
  },
  {
    value: null,
    label: 'Not Submitted',
  },
];

const completeOptions = [
  {
    value: true,
    label: 'Completed',
    backgroundColor: '#E7F7E1',
    color: '#8ED76E',
  },
  {
    value: null,
    label: 'Not Completed',
  },
];

const LOROptions = [
  {
    value: true,
    label: 'Submitted',
    backgroundColor: '#E7F7E1',
    color: '#8ED76E',
  },
  {
    value: 'requested',
    label: 'Requested',
  },
  {
    value: null,
    label: 'Not Requested',
  },
];

const CollegeInfo = ({ school, classes, canEdit, updateSchool }) => {
  const snack = useSnack();

  const [editInput, setEditInput] = useState(false);

  const [state, setState] = useState({
    essay_completed: school?.tracker_info?.essay_completed || null,
    testing_req: school?.tracker_info?.testing_req || null,
    test_scores: school?.tracker_info?.test_scores || null,
    sat_subject_test: school?.tracker_info?.sat_subject_test || null,
    transcript: school?.tracker_info?.transcript || null,
    LOR_req: school?.tracker_info?.LOR_req || null,
    LOR_submitted: school?.tracker_info?.LOR_submitted || null,
    fafsa: school?.tracker_info?.fafsa || null,
    css_profile: school?.tracker_info?.css_profile || null,
    scholarship_app: school?.tracker_info?.scholarship_app || null,
    honors_app: school?.tracker_info?.honors_app || null,
    scholarship_deadline: school?.tracker_info?.scholarship_deadline || null,
    interviews: school?.tracker_info?.interviews || null,
    honors_deadline: school?.tracker_info?.honors_deadline || null,
    admission_notif_date: school?.tracker_info?.admission_notif_date || null,
    notes: school?.tracker_info?.notes || null,
  });

  const onScholarshipDeadlineDateChange = (date) => {
    updateSchool({
      variables: {
        id: school.id,
        input: {
          tracker_info: {
            ...state,
            scholarship_deadline: date.format('YYYY-MM-DD'),
          },
        },
      },
    })
      .then(() => {
        setState({
          ...state,
          scholarship_deadline: date.format('YYYY-MM-DD'),
        });
        snack.success('Saved');
      })
      .catch((e) => snack.error(e.message));
  };

  const onHonorsDeadlineDateChange = (date) => {
    updateSchool({
      variables: {
        id: school.id,
        input: {
          tracker_info: {
            ...state,
            honors_deadline: date.format('YYYY-MM-DD'),
          },
        },
      },
    })
      .then(() => {
        setState({
          ...state,
          honors_deadline: date.format('YYYY-MM-DD'),
        });
        snack.success('Saved');
      })
      .catch((e) => snack.error(e.message));
  };

  const onNotificationDateChange = (date) => {
    updateSchool({
      variables: {
        id: school.id,
        input: {
          tracker_info: {
            ...state,
            admission_notif_date: date.format('YYYY-MM-DD'),
          },
        },
      },
    })
      .then(() => {
        setState({
          ...state,
          admission_notif_date: date.format('YYYY-MM-DD'),
        });
        snack.success('Saved');
      })
      .catch((e) => snack.error(e.message));
  };

  const handleChange = async (name, val) => {
    await updateSchool({
      variables: {
        id: school.id,
        input: {
          tracker_info: { ...state, [name]: val },
        },
      },
    })
      .then(() => {
        setState({
          ...state,
          [name]: val,
        });
        snack.success('Saved');
      })
      .catch((e) => snack.error(e.message));
  };

  const handleInput = (evt) => {
    const value = evt.target.value;
    setState({
      ...state,
      [evt.target.name]: value,
    });
  };

  const onSave = () => {
    updateSchool({
      variables: {
        id: school.id,
        input: {
          tracker_info: state,
        },
      },
    })
      .then(() => {
        snack.success('Saved');
        setEditInput(false);
      })
      .catch((e) => snack.error(e.message));
  };

  return (
    <div>
      <Box display="flex" justifyContent="space-between" marginBottom={2}>
        <Typography>Essay(s)</Typography>
        <Dropdown
          id="essay_completed"
          name="essay_completed"
          options={completeOptions}
          disabled={!canEdit}
          value={school?.tracker_info?.essay_completed}
          style={{ marginRight: 8 }}
          onChange={(e) => handleChange('essay_completed', e)}
          color={
            completeOptions.find(
              (s) => s.value === school?.tracker_info?.essay_completed,
            )?.color || 'inherit'
          }
          backgroundColor={
            completeOptions.find(
              (s) => s.value === school?.tracker_info?.essay_completed,
            )?.backgroundColor || 'inherit'
          }
        />
      </Box>
      <Divider />
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        marginBottom={2}
        marginTop={2}
      >
        <Typography>Testing Requirements</Typography>
        <div>
          {editInput ? (
            <>
              <TextField
                classes={{
                  root: classes.textfield,
                }}
                name="testing_req"
                defaultValue={school?.tracker_info?.testing_req}
                onChange={handleInput}
                multiline
              />
              <IconButton size="small" onClick={onSave}>
                <SaveIcon
                  classes={{
                    fontSizeSmall: classes.icon,
                  }}
                  fontSize="small"
                />
              </IconButton>
            </>
          ) : (
            <>
              <Typography variant={school?.tracker_info?.testing_req ? "body2" : 'caption'}>
                <span>{school?.tracker_info?.testing_req || `Type here...`}</span>
                <IconButton size="small" onClick={() => setEditInput(true)}>
                  <EditIcon
                    classes={{
                      fontSizeSmall: classes.icon,
                    }}
                    fontSize="small"
                  />
                </IconButton>
              </Typography>
            </>
          )}
        </div>
      </Box>
      <Divider />
      <Box
        display="flex"
        justifyContent="space-between"
        marginBottom={2}
        marginTop={2}
      >
        <Typography>SAT/ACT Test Scores</Typography>
        <Dropdown
          disableUnderline
          displayEmpty
          id="test_scores"
          name="test_scores"
          disabled={!canEdit}
          value={school?.tracker_info?.test_scores}
          onChange={(e) => handleChange('test_scores', e)}
          options={submitOptions}
          color={
            submitOptions.find(
              (s) => s.value === school?.tracker_info?.test_scores,
            )?.color
          }
        />
      </Box>
      <Divider />
      <Box
        display="flex"
        justifyContent="space-between"
        marginBottom={2}
        marginTop={2}
      >
        <Typography>SAT Subject Test Scores</Typography>
        <Dropdown
          id="sat_subject_test"
          name="sat_subject_test"
          disabled={!canEdit}
          value={school?.tracker_info?.sat_subject_test}
          style={{ marginRight: 8 }}
          onChange={(e) => handleChange('sat_subject_test', e)}
          options={submitOptions}
          color={
            submitOptions.find(
              (s) => s.value === school?.tracker_info?.sat_subject_test,
            )?.color
          }
        />
      </Box>
      <Divider />
      <Box
        display="flex"
        justifyContent="space-between"
        marginBottom={2}
        marginTop={2}
      >
        <Typography>Transcript(s)</Typography>
        <Dropdown
          id="transcript"
          name="transcript"
          disabled={!canEdit}
          value={school?.tracker_info?.transcript}
          style={{ marginRight: 8 }}
          onChange={(e) => handleChange('transcript', e)}
          color={
            submitOptions.find(
              (s) => s.value === school?.tracker_info?.transcript,
            )?.color
          }
          options={submitOptions}
        />
      </Box>
      <Divider />
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        marginBottom={2}
        marginTop={2}
      >
        <Typography>Letters of Recommendation Requirements</Typography>
        <div>
          {editInput ? (
            <>
              <TextField
                classes={{
                  root: classes.textfield,
                }}
                name="LOR_req"
                defaultValue={school?.tracker_info?.LOR_req}
                onChange={handleInput}
                multiline
              />
              <IconButton size="small" onClick={onSave}>
                <SaveIcon
                  classes={{
                    fontSizeSmall: classes.icon,
                  }}
                  fontSize="small"
                />
              </IconButton>
            </>
          ) : (
            <>
            <Typography variant={school?.tracker_info?.LOR_req ? "body2" : 'caption'}>
                <span>{school?.tracker_info?.LOR_req || `Type here...`}</span>
                <IconButton size="small" onClick={() => setEditInput(true)}>
                  <EditIcon
                    classes={{
                      fontSizeSmall: classes.icon,
                    }}
                    fontSize="small"
                  />
                </IconButton>
              </Typography>
            </>
          )}
        </div>
      </Box>
      <Divider />
      <Box
        display="flex"
        justifyContent="space-between"
        marginBottom={2}
        marginTop={2}
      >
        <Typography>Letters of Recommendation Status </Typography>
        <Dropdown
          id="LOR_submitted"
          name="LOR_submitted"
          disabled={!canEdit}
          value={school?.tracker_info?.LOR_submitted}
          style={{ marginRight: 8 }}
          onChange={(e) => handleChange('LOR_submitted', e)}
          options={LOROptions}
          color={
            LOROptions.find(
              (s) => s.value === school?.tracker_info?.LOR_submitted,
            )?.color
          }
        />
      </Box>
      <Divider />
      <Box
        display="flex"
        justifyContent="space-between"
        marginBottom={2}
        marginTop={2}
      >
        <Typography>FAFSA</Typography>
        <Dropdown
          id="fafsa"
          name="fafsa"
          disabled={!canEdit}
          value={school?.tracker_info?.fafsa}
          style={{ marginRight: 8 }}
          onChange={(e) => handleChange('fafsa', e)}
          options={submitOptions}
          color={
            submitOptions.find((s) => s.value === school?.tracker_info?.fafsa)
              ?.color
          }
        />
      </Box>
      <Divider />
      <Box
        display="flex"
        justifyContent="space-between"
        marginBottom={2}
        marginTop={2}
      >
        <Typography>CSS Profile</Typography>
        <Dropdown
          id="css-profile"
          name="css_profile"
          disabled={!canEdit}
          options={submitOptions}
          value={school?.tracker_info?.css_profile}
          style={{ marginRight: 8 }}
          onChange={(e) => handleChange('css_profile', e)}
          color={
            submitOptions.find(
              (s) => s.value === school?.tracker_info?.css_profile,
            )?.color
          }
        />
      </Box>
      <Divider />
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        marginBottom={2}
        marginTop={2}
      >
        <Typography>Separate Scholarship Application</Typography>
        <div>
          {editInput ? (
            <>
              <TextField
                classes={{
                  root: classes.textfield,
                }}
                name="scholarship_app"
                defaultValue={school?.tracker_info?.scholarship_app}
                onChange={handleInput}
                multiline
              />
              <IconButton size="small" onClick={onSave}>
                <SaveIcon
                  classes={{
                    fontSizeSmall: classes.icon,
                  }}
                  fontSize="small"
                />
              </IconButton>
            </>
          ) : (
            <>
            <Typography variant={school?.tracker_info?.scholarship_app ? "body2" : 'caption'}>
                <span>{school?.tracker_info?.scholarship_app || `Type here...`}</span>
                <IconButton size="small" onClick={() => setEditInput(true)}>
                  <EditIcon
                    classes={{
                      fontSizeSmall: classes.icon,
                    }}
                    fontSize="small"
                  />
                </IconButton>
              </Typography>
            </>
          )}
        </div>
      </Box>
      <Divider />
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        marginBottom={2}
        marginTop={2}
      >
        <Typography style={{ flex: 3 }}>
          Scholarship Application Deadline
        </Typography>
        <DatePickerLabel
          value={school?.tracker_info?.scholarship_deadline || null}
          onChange={onScholarshipDeadlineDateChange}
        />
      </Box>
      <Divider />
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        marginBottom={2}
        marginTop={2}
      >
        <Typography>Interviews</Typography>
        <div>
          {editInput ? (
            <>
              <TextField
                classes={{
                  root: classes.textfield,
                }}
                name="interviews"
                defaultValue={school?.tracker_info?.interviews}
                onChange={handleInput}
                multiline
              />
              <IconButton size="small" onClick={onSave}>
                <SaveIcon
                  classes={{
                    fontSizeSmall: classes.icon,
                  }}
                  fontSize="small"
                />
              </IconButton>
            </>
          ) : (
            <>
            <Typography variant={school?.tracker_info?.interviews ? "body2" : 'caption'}>
                <span>{school?.tracker_info?.interviews || `Type here...`}</span>
                <IconButton size="small" onClick={() => setEditInput(true)}>
                  <EditIcon
                    classes={{
                      fontSizeSmall: classes.icon,
                    }}
                    fontSize="small"
                  />
                </IconButton>
              </Typography>
            </>
          )}
        </div>
      </Box>
      <Divider />
      <Box
        display="flex"
        justifyContent="space-between"
        marginBottom={2}
        marginTop={2}
      >
        <Typography>Separate Honors College Application</Typography>
        <Dropdown
          id="honors_app"
          name="honors_app"
          disabled={!canEdit}
          value={school?.tracker_info?.honors_app}
          options={submitOptions}
          style={{ marginRight: 8 }}
          onChange={(e) => handleChange('honors_app', e)}
          color={
            submitOptions.find(
              (s) => s.value === school?.tracker_info?.honors_app,
            )?.color
          }
        />
      </Box>
      <Divider />
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        marginBottom={2}
        marginTop={2}
      >
        <Typography style={{ flex: 3 }}>
          Honors College Application Deadline{' '}
        </Typography>
        <DatePickerLabel
          value={school?.tracker_info?.honors_deadline || null}
          onChange={onHonorsDeadlineDateChange}
        />
      </Box>
      <Divider />
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        marginBottom={2}
        marginTop={2}
      >
        <Typography style={{ flex: 3 }}>
          Admission Decision Notification Date
        </Typography>
        <DatePickerLabel
          value={school?.tracker_info?.admission_notif_date || null}
          onChange={onNotificationDateChange}
        />
      </Box>
      <Divider />
      <Box
        display="flex"
        justifyContent="space-between"
        flexDirection='column'
        marginBottom={2}
        marginTop={2}
      >
        <Typography>Notes</Typography>
        <div>
          {editInput ? (
            <>
              <TextField
                classes={{
                  root: classes.textfieldNotes,
                }}
                name="notes"
                defaultValue={school?.tracker_info?.notes}
                onChange={handleInput}
                multiline
              />
              <IconButton size="small" onClick={onSave}>
                <SaveIcon
                  classes={{
                    fontSizeSmall: classes.icon,
                  }}
                  fontSize="small"
                />
              </IconButton>
            </>
          ) : (
            <>
            <Typography variant={school?.tracker_info?.notes ? "body2" : 'caption'}>
                <span>{school?.tracker_info?.notes|| `Type here...`}</span>
                <IconButton size="small" onClick={() => setEditInput(true)}>
                  <EditIcon
                    classes={{
                      fontSizeSmall: classes.icon,
                    }}
                    fontSize="small"
                  />
                </IconButton>
              </Typography>
            </>
          )}
        </div>
      </Box>
    </div>
  );
};

export default CollegeInfo;
